<template>
  <div id="index">
    <div class="header">
      <div class="headerBox">您好，欢迎来到亳药师！&nbsp;&nbsp;<a v-show="showLogin" @click="goLogin">请登录</a>&nbsp;&nbsp;<a  v-show="showLogin" @click="goRegister">免费注册</a></div>
    </div>
    <div class="search">
      <div class="searchBox">
        <img src="../assets/img/logo.png" @click="goIndex" alt="亳药师" >
        <input v-model="searchText" />
        <button type="primary" @click="search"><img src="../assets/img/searchIcon.png" alt="搜索">搜索</button>
        <p @click="showEWM"  v-show="EWMButton"><img src="../assets/img/mobileIcon.png" alt="关注公众号"> 关注公众号</p>
        <img v-show="EWMImg" @click="showButton" src="../assets/img/footerImg.jpg" alt="关注公众号" class="EWMImg">
      </div>
    </div>
    <div class="index1" style="height:66px;overflow:hidden">
      <div class="index1Box">
        <div class="index1Left">
          <h4><img src="../assets/img/menuIcon.png" alt="">所有产品分类</h4>
          <ul style="display:none">
            <li class="index1LeftActive">
              <h6>动矿物+</h6>
              <p>
                <a href="">醋鸡内金、</a>
                <a href="">醋鳖甲、</a>
                <a href="">麸炒僵蚕、</a>
                <a href="">龙骨、</a>
                <a href="">煅龙齿、</a>
                <a href="">大青盐、</a>
                <a href="">牡蛎、</a>
                <a href="">龙齿</a>
              </p>
            </li>
            <li>
              <h6>根茎+</h6>
              <p>
                <a href="">醋鸡内金、</a>
                <a href="">醋鳖甲、</a>
                <a href="">麸炒僵蚕、</a>
                <a href="">龙骨、</a>
                <a href="">煅龙齿、</a>
                <a href="">大青盐、</a>
                <a href="">牡蛎、</a>
                <a href="">龙齿</a>
              </p>
            </li>
            <li>
              <h6>动矿物+</h6>
              <p>
                <a href="">醋鸡内金、</a>
                <a href="">醋鳖甲、</a>
                <a href="">麸炒僵蚕、</a>
                <a href="">龙骨、</a>
                <a href="">煅龙齿、</a>
                <a href="">大青盐、</a>
                <a href="">牡蛎、</a>
                <a href="">龙齿</a>
              </p>
            </li>
            <li>
              <h6>根茎+</h6>
              <p>
                <a href="">醋鸡内金、</a>
                <a href="">醋鳖甲、</a>
                <a href="">麸炒僵蚕、</a>
                <a href="">龙骨、</a>
                <a href="">煅龙齿、</a>
                <a href="">大青盐、</a>
                <a href="">牡蛎、</a>
                <a href="">龙齿</a>
              </p>
            </li>
            <li>
              <h6>根茎+</h6>
              <p>
                <a href="">醋鸡内金、</a>
                <a href="">醋鳖甲、</a>
                <a href="">麸炒僵蚕、</a>
                <a href="">龙骨、</a>
                <a href="">煅龙齿、</a>
                <a href="">大青盐、</a>
                <a href="">牡蛎、</a>
                <a href="">龙齿</a>
              </p>
            </li>
          </ul>
        </div>
        <div class="index1Right">
          <ul class="index1RightNav">
            <li :class="activeClass == index ? 'navActive':''" v-for="(item,index) in navList" :key="index" @click="goNav(item.go,index)">{{item.name}}</li>
            <!-- <li><a @click="goOfferList">推荐资源</a></li>
            <li><a @click="goNewslist">药材资讯</a></li>
            <li><a @click="goProductList">自营产品</a></li> -->
            <!-- <li><a href="">合作伙伴</a></li> -->
          </ul>
        </div>
      </div>
    </div>
    <div  v-show="searchDiv">
      <div class="banner">
        <div>
          <!-- <img src="../assets/img/bannerImg.png" alt=""> -->
        </div>
      </div>
      <!-- 推荐产品 -->
      <div class="index5 productList">
        <div class="index5Box productListBox">
          <!-- 报价搜索 -->
          <!-- <div class="offerSearch">
            <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="input2"></el-input>
            <button type="primary">搜索</button>
          </div> -->
          <ul>
            <li v-for="item in searchList" :key="item.id"  @click="goProductDetails(item.id)">
              <img :src="item.images" />
              <p>{{item.goodName}}&nbsp;{{item.chandi}}</p>
              <p><span>价格电议</span> </p>
            </li>
          </ul>
        </div>
        <div class="pageBox" v-show="showPage">
          <el-pagination background layout="prev, pager, next" :currentPage="currentPage" :pageSize ="pageSize" :total="totalNum"  @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
    </div>
    <Login ref="login"></Login>
    <Register ref="register"></Register>
  </div>
</template>
<script>
import Login from '../components/login'
import Register from '../components/register'
import SearchList from '../components/searchList'
export default {
  components: {
    Login,
    Register,
    SearchList
  },
  data() {
    return {
      showPage:true,
      searchText:'',
      searchDiv:false,
      searchList:[],
      activeClass: -1, 	// 0为默认选择第一个，-1为不选择
      navList:[
        {go:'Index',name:'首页'},
        {go:'OfferList',name:'推荐资源'},
        {go:'DynamicsList',name:'药材交易动态'},
        {go:'NewsList',name:'新闻资讯'},
        {go:'ProductList',name:'自营产品'}
      ],
      showLogin:true,
      showAfterLogin:false,
      grouplist:[],//分类
      twoGrouplist:[],//二级分类
      EWMImg:false,
      EWMButton:true,
      loginDialog: false,
      registerDialog:false,
      showProduct:false,
      currentPage: 1,//默认显示第一页
      pageSize:10,//默认每页显示10条
      totalNum: 100 //总页数
    }
  },
  watch: {
    searchDiv(newValue, oldValue) {
      if(this.searchDiv == true){
        if(this.$parent.morenDiv == true){
          this.$parent.morenDiv = false
        }
      }
    },
    deep:true
  },
  mounted() {
    if(this.$cookie.get('account') == null){
      this.showLogin = true
      this.showAfterLogin = false
    }else{
      this.showLogin = false
      this.showAfterLogin = true
    }
    if(this.searchDiv == true){
      this.$refs.morenDiv.show();
    }
    this.activeClass = this.$cookie.get('navIndex')
    this.getGroupList();
  },
  methods: {
    search(){
      this.$fetch('getSearchList',{goodName:this.searchText,pageNo:this.currentPage,pageSize:this.pageSize}).then(res => {
        this.searchList = res.result.records;
        if(res.result.records.length<=0){this.showPage = false}
        this.$cookie.set('morenDiv',1)
        this.totalNum = res.result.total;
        this.searchDiv = true
      })
    },
    handleSizeChange(val) {
      this.pageSize = val;    //动态改变
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //分类
    getGroupList(){
      this.$fetch('getGroupList').then(res => {
       this.grouplist = res.result;
      })
    },
    // 点击显示二维码
    showEWM(){
      this.EWMImg = true;
      this.EWMButton = false
    },
    // 点击显示二级药材
    showTwoProduct(data,index){
      if(this.showProduct == true){
        this.showProduct = false
      }else{
        this.showProduct = true;
        this.twoGrouplist = [JSON.parse(JSON.stringify(data))];
        this.activeClass = index
      }
    },
    hideTwoProduct(){
      this.showProduct = false
    },
    showTwoProductDiv(){
      this.showProduct = true
    },
    // 点击显示关注按钮
    showButton(){
      this.EWMImg = false;
      this.EWMButton = true;
    },
    goIndex(){
      this.$router.push({path:'/'})
    },
    goLogin(){
      this.$refs.login.toLogin();
    },
    goRegister(){
      this.$refs.register.toRegister();
    },
    goNav(go,index){
      this.$cookie.set('navIndex',index);
      this.$router.push(go)
    },
    //跳转产品详情
    goProductDetails(id){
      this.$router.push({name:'ProductDetails',query: {id:id}})
    },
  }
}
</script>
<style>
  @import "../assets/css/style.css";
</style>



// WEBPACK FOOTER //
// src/components/header.vue